// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main__3ZkGI","darkMode":"App_darkMode__2TPkn","h2":"App_h2__2_lG-","paragraph":"App_paragraph__1-Bqp","emoji":"App_emoji__Vcubs"};